import React from 'react';

import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import ExportView from '@dashboard/components/ExportView';
import SearchInput from '@dashboard/components/Form/components/SearchInput';
import FilterInput from '@dashboard/components/Form/components/FilterInput';
import { SubmissionsList } from '@dashboard/scenes/Submissions';

import usePage from '@dashboard/hooks/usePage';
import useUrlState from '@dashboard/hooks/useUrlState';
import useTableSort from '@dashboard/hooks/useTableSort';
import { getStatusFromQuery } from '@dashboard/lib/tableHelpers';

const FILTER_OPTIONS = {
  ALL: {
    label: 'All',
    value: 'all',
  },
  SUCCEEDED: {
    label: 'Succeeded',
    value: 'succeeded',
  },
  FAILED: {
    label: 'Failed',
    value: 'failed',
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
  },
};

const PageSubmissions = () => {
  const { page } = usePage();
  const [query, setParams] = useUrlState();
  const { sorting, onSortingChange, sort } = useTableSort();

  const search = query.search || '';
  const status = getStatusFromQuery(query.status, FILTER_OPTIONS);

  const filter = {
    ...(FILTER_OPTIONS[status].value !== 'all' && {
      status: FILTER_OPTIONS[status].value,
    }),
    page: page._id,
    livemode: true,
  };

  const handleSearchChange = value => setParams({ search: value || undefined });

  const handleStatusChange = key =>
    setParams({
      status: FILTER_OPTIONS[key].value === 'all' ? undefined : FILTER_OPTIONS[key].value,
    });

  return (
    <div className="mb-24">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 pb-4">
        <CardHeaderTitle variant="page">Submissions</CardHeaderTitle>

        <div className="flex flex-wrap items-center gap-2 max-lg:w-full [&>*:first-child]:min-w-0 max-lg:[&>*:first-child]:flex-1 max-lg:[&>*:first-child]:basis-56 max-sm:[&>*:first-child]:basis-full">
          <SearchInput
            onChange={handleSearchChange}
            name="search_submissions"
            placeholder="Search by email"
            initialValue={search}
          />
          <FilterInput options={FILTER_OPTIONS} onChange={handleStatusChange} value={status} />
          <ExportView
            collection="submissions"
            label="submissions"
            filters={{
              ...filter,
              page: page._id,
              sort: JSON.stringify(sort),
              search,
            }}
          />
        </div>
      </div>

      <SubmissionsList
        filter={filter}
        sort={sort}
        search={search}
        options={{ hidePageName: true }}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
    </div>
  );
};

export default PageSubmissions;
